import type { GameViewOption } from './game-list/recommend-game-groups/GroupGameProps'

export const GRID_MAX_SIZE = 18
export const GRID_COLUMNS = { base: 3, sm: 4, md: 5, lg: 6 }
export const DEFAULT_GAME_VIEW_OPTION: GameViewOption = {
  rowsPerView: 1,
  loadMoreType: 1,
  coverOrientation: 'portrait',
}
